var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttom"},[_c('div',[_vm._v(" 免责声明：本站部分资讯来源于网络，如有侵权请及时联系客服，我们将尽快处理 ")]),_c('div',[_vm._v(" 深圳市益汇投资控股有限公司版权所有 "),_c('a',{attrs:{"href":"http://beian.miit.gov.cn"}},[_vm._v("粤ICP备18146311号")])])])
}]

export { render, staticRenderFns }